var map = {
	"./Customers.png": 962,
	"./Generate Bill.png": 2741,
	"./Licenses details.png": 7743,
	"./Licenses.png": 3181,
	"./PO Details.png": 9240,
	"./Purchase Orders.png": 7933,
	"./Transaction Reciept.jpeg": 538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6432;